import { usePageForm } from 'scbk-shared-module/modules/Form';
import { useTokensStore } from '../stores/useTokensStore';
import { tokensRulesBuilder } from '../utils/tokensRulesBuilder';

export interface OTPProps {
  otpNumber: string;
  transPassword: string;
  phoneNo1: string;
  phoneNo2: string;
  phoneNo3: string;
}

interface OldOTPProps {
  otpNumber: string;
  transPassword: string;
  phoneNo1: string;
  phoneNo2: string;
  phoneNo3: string;
}

interface MOTPProps {
  pinBb01: string;
  transPassword: string;
  phoneNo1: string;
  phoneNo2: string;
  phoneNo3: string;
}

interface PcMOTPProps {
  pinNumber: string;
  transPassword: string;
  phoneNo1: string;
  phoneNo2: string;
  phoneNo3: string;
}

interface SafeCardProps {
  safeCardSeqValue: string;
  safeCardNumber1: string;
  safeCardNumber2: string;
  transPassword: string;
  phoneNo1: string;
  phoneNo2: string;
  phoneNo3: string;
}

interface TranPasswordProps {
  transPassword: string;
}

export const useOTPPageForm = () => {
  const { activateInfo } = useTokensStore();

  const form = usePageForm<OTPProps>({
    defaultValues: {
      otpNumber: '',
      transPassword: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    otpNumber: {
      rules: tokensRulesBuilder<OTPProps>().otpNumber().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<OTPProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<OTPProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<OTPProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<OTPProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const useOldOTPPageForm = () => {
  const { activateInfo } = useTokensStore();

  const form = usePageForm<OldOTPProps>({
    defaultValues: {
      otpNumber: '',
      transPassword: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    otpNumber: {
      rules: tokensRulesBuilder<OldOTPProps>().otpNumber().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<OldOTPProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<OldOTPProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<OldOTPProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<OldOTPProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const useDefaultSafeCardPageForm = () => {
  const { activateInfo } = useTokensStore();

  console.log(activateInfo);

  const form = usePageForm<SafeCardProps>({
    defaultValues: {
      safeCardNumber1: '',
      safeCardNumber2: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    safeCardNumber1: {
      rules: tokensRulesBuilder<SafeCardProps>().safeCardNumber1().build(),
    },
    safeCardNumber2: {
      rules: tokensRulesBuilder<SafeCardProps>().safeCardNumber2().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<SafeCardProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const useSafeCardPageForm = () => {
  const { activateInfo } = useTokensStore();

  const form = usePageForm<SafeCardProps>({
    defaultValues: {
      safeCardSeqValue: '',
      safeCardNumber1: '',
      safeCardNumber2: '',
      transPassword: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    ...(activateInfo?.safeCardSeq1 &&
      activateInfo.safeCardSeq2 &&
      activateInfo.safeCardSeq3 && {
        safeCardSeqValue: {
          rules: tokensRulesBuilder<SafeCardProps>().safeCardSeqValue().build(),
        },
      }),
    safeCardNumber1: {
      rules: tokensRulesBuilder<SafeCardProps>().safeCardNumber1().build(),
    },
    safeCardNumber2: {
      rules: tokensRulesBuilder<SafeCardProps>().safeCardNumber2().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<SafeCardProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<SafeCardProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const useMOTPPageForm = () => {
  const { activateInfo } = useTokensStore();

  const form = usePageForm<MOTPProps>({
    defaultValues: {
      pinBb01: '',
      transPassword: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    pinBb01: {
      rules: tokensRulesBuilder<MOTPProps>().mOtpNumber().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<MOTPProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<MOTPProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<MOTPProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<MOTPProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const usePcMOTPPageForm = () => {
  const { activateInfo } = useTokensStore();

  const form = usePageForm<PcMOTPProps>({
    defaultValues: {
      pinNumber: '',
      transPassword: '',
      phoneNo1: activateInfo?.telNo1 || '010',
      phoneNo2: activateInfo?.telNo2,
      phoneNo3: activateInfo?.telNo3,
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    pinNumber: {
      rules: tokensRulesBuilder<PcMOTPProps>().mOtpNumber().build(),
    },
    ...(activateInfo?.tranPwdYn === 'Y' && {
      transPassword: {
        rules: tokensRulesBuilder<PcMOTPProps>().transPassword().build(),
      },
    }),
    phoneNo1: {
      rules: tokensRulesBuilder<PcMOTPProps>().phoneNo1().build(),
    },
    phoneNo2: {
      rules: tokensRulesBuilder<PcMOTPProps>().phoneNo2().build(),
    },
    phoneNo3: {
      rules: tokensRulesBuilder<PcMOTPProps>().phoneNo3().build(),
    },
  });

  return {
    form,
    fields,
  };
};

export const useTranPasswordPageForm = () => {
  const form = usePageForm<TranPasswordProps>({
    defaultValues: {
      transPassword: '',
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    transPassword: {
      rules: tokensRulesBuilder<TranPasswordProps>().transPassword().build(),
    },
  });

  return {
    form,
    fields,
  };
};
